/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Criteria_CreatedInputs */

const en_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search criteria created`)
};

const de_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchkriterium erstellt`)
};

const fr_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critère de recherche créé`)
};

const es_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criterio de búsqueda creado`)
};

const it_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criterio di ricerca creato`)
};

const nl_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoekcriterium aangemaakt`)
};

const pl_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kryterium wyszukiwania utworzone`)
};

const fi_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakukriteeri luotu`)
};

const da_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søgekriterium oprettet`)
};

const sv_jobs_criteria_created = /** @type {(inputs: Jobs_Criteria_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sökkriterium skapat`)
};

/**
* | output |
* | --- |
* | "Search criteria created" |
*
* @param {Jobs_Criteria_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_criteria_created = /** @type {((inputs?: Jobs_Criteria_CreatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Criteria_CreatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_criteria_created(inputs)
	if (locale === "fr") return fr_jobs_criteria_created(inputs)
	if (locale === "es") return es_jobs_criteria_created(inputs)
	if (locale === "it") return it_jobs_criteria_created(inputs)
	if (locale === "nl") return nl_jobs_criteria_created(inputs)
	if (locale === "pl") return pl_jobs_criteria_created(inputs)
	if (locale === "fi") return fi_jobs_criteria_created(inputs)
	if (locale === "da") return da_jobs_criteria_created(inputs)
	if (locale === "sv") return sv_jobs_criteria_created(inputs)
	return en_jobs_criteria_created(inputs)
});